export default class Str {
  public static readonly capitalizeFirst = (string: string): string => {
    return string[0].toUpperCase() + string.slice(1);
  };

  public static readonly slugify = (string: string): string => {
    return string
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  public static formatPercents = (percents: number): string => {
    return `${percents} %`;
  };

  public static readonly toPascalCase = (string: string): string => {
    string = Str.slugify(string);

    const parts = string.split('-');
    if (!parts.length) {
      return Str.capitalizeFirst(string);
    }

    return parts.map((str) => Str.capitalizeFirst(str)).join('');
  };

  public static wrapHrefs = (str: string): string => {
    const rgx = new RegExp(
      /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.?[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_\+.~#?&\/\/=]*)/g,
    );

    return str.replace(rgx, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener" class="tw-text-blue tw-underline-offset-4 hover:!tw-underline">${url}</a>`;
    });
  };

  // Helper function to strip markdown formatting
  public static stripMarkdown = (text: unknown): string => {
    if (typeof text !== 'string') return '';

    // Code spans and escaped characters (\_ \*) are literal: set them aside so the
    // passes below can't touch them, and put them back at the end.
    const literals: string[] = [];
    const keep = (value: string) => `\u0000${literals.push(value) - 1}\u0000`;
    let cleaned = text
      .replace(/\\([\\`*_#>~])/g, (_match, char: string) => keep(char))
      .replace(/`([^`]+)`/g, (_match, code: string) => keep(code));

    // Remove bold/italic markdown (**, *)
    cleaned = cleaned.replace(/\*{1,2}([^*]+)\*{1,2}/g, '$1');
    // Underscore emphasis (__x__, _x_) only where markdown would see it: opened after a
    // space, the start or an opening bracket/quote, and closed before a space, the end or
    // punctuation, with the same number of underscores. Underscores that are part of a
    // value stay: acme_studio, first_last@acme.com, instagram.com/_acme_, @_acme_.
    cleaned = cleaned.replace(
      /(^|[\s([{"'])(_{1,2})(?=[^\s_])([^\n]*?[^\s_])\2(?=$|[\s.,;:!?)\]}"'])/gu,
      '$1$3',
    );
    // Remove any remaining markdown symbols as needed (not _, see above)
    cleaned = cleaned.replace(/[*`#>~]/g, '');

    // eslint-disable-next-line no-control-regex
    return cleaned.replace(/\u0000(\d+)\u0000/g, (_match, i: string) => literals[Number(i)]).trim();
  };

  public static trimBrackets(str?: string): string {
    if (!str) return '';
    if (str.startsWith('[') && str.endsWith(']')) {
      return str.slice(1, -1);
    }
    return str;
  }
}
